import { render, staticRenderFns } from "./TabRegistryMessage.vue?vue&type=template&id=7f8849ee&"
import script from "./TabRegistryMessage.vue?vue&type=script&lang=js&"
export * from "./TabRegistryMessage.vue?vue&type=script&lang=js&"
import style0 from "./TabRegistryMessage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports